export const actionTypes = {
    fetchPatients: 'FETCH_PATIENTS',
    receivePatients: 'RECEIVE_PATIENTS',
    clearPatients : 'CLEAR_PATIENTS'
};

export const clearPatients = { type: actionTypes.clearPatients };

